import { useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, Modal, showToast } from "../../../../../../components";
import { useSelector } from "react-redux";
import { addAllLocalRestrictionApi } from "../../../../../../redux/slices/setting/settingApi";

const GeneralSettingsAddButtonModal = ({
  showAddButtonModal,
  setShowAddButtonModal,
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    stateName: "",
    stateCode: "",
  });
  const [loading, setLoading] = useState(false);
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };
  const { user } = useSelector((state) => state.auth);
  const handleSave = async () => {
    if (!formData.stateName || !formData.stateCode) {
      showToast("Please fill all fields","error");
      return;
    }
    try {
      setLoading(true);

      // const payload = 

      const response = await addAllLocalRestrictionApi({
        coll: "LocationRestriction",
        payload: {
          stateName: formData.stateName,
          stateCode: formData.stateCode,
          addedBy: user?.data?.uiid, 
        },
      });
      //console.log("Add Restriction Response:", response);

      if(response?.data) {
        showToast("Restriction added successfully!","success");
        setFormData({
          stateName: "",
          stateCode: "",
        });
        setShowAddButtonModal(false);
        if (onSuccess) onSuccess();
      } else {
        showToast("Failed to add restriction","error")
      }

    } catch (error) {
      console.error("Error adding local restriction:", error);
      showToast("Failed to add restriction. Please try again.","error");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      stateName: "",
      stateCode: "",
    });
    setShowAddButtonModal(false)
  }

  return (
    
    <Modal
      isOpen={showAddButtonModal}
      onClose={handleClose}
      title="Details"
      titleColor={"primary"}
      width="max-w-xl"
    >
      <div className="grid grid-cols-2 gap-3 my-3">
        <FormFieldSet
          title="State Full Name"
          placeholder="Enter State Full Name"
          value={formData.stateName}
          required
          onChange={(value) => handleChange("stateName", value)}
        />
        <FormFieldSet 
        title="State Code" 
        required
        placeholder="Enter State Code"
        value={formData.stateCode}
        disabled={!formData.stateName}
        onChange={(value) => handleChange("stateCode", value)}
          />
      </div>
      <div className="flex items-center justify-end gap-2 mt-20">
        <Button
          variant="outlined"
          title="Cancel"
          size="sm"
          onClick={handleClose}
          disabled={loading}
        />
        <Button title="Save" size="sm" onClick={handleSave} />
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </Modal>
  );
};

export default GeneralSettingsAddButtonModal;
